import { Tabs, Loading, Pagination } from 'components/elements'
import { withSizes } from 'components/helpers'
import { useSession } from 'context/Session'
import { useRouter } from 'next/router'
import * as R from 'ramda'
import { useState } from 'react'
import { useQuery } from 'react-query'

import * as S from './List.styles'
import { doLoadGroups } from '../modules/datasource'

const defaultProps = {}
const propTypes = {}

export const List = ({ user, isMobile }) => {
  const { loadGroups, user: sessionUser } = useSession()
  const router = useRouter()
  const [crrListState, setListState] = useState([])
  const { list: crrList, total } = crrListState || {}
  const accessToken = user?.accessToken
  const { tab = 'Latest', page = 1 } = router.query

  const hasUser = !!user

  const tabs = [
    { label: 'Latest', value: 'Latest' },
    hasUser ? { label: 'Joined', value: 'Joined' } : {},
    { label: 'Popular', value: 'Trending' },
  ]

  const crrTab = R.any(R.propEq(tab, 'value'), tabs) ? tab : 'published'
  const isCrrTabJoined = crrTab === 'Joined'

  const changeTab = tab => {
    window?.scroll(0, 0)
    router.push(`/groups?tab=${tab}`, undefined, {
      shallow: true,
    })
  }

  const changePage = page => {
    window?.scroll(0, 0)
    router.push(`/groups?tab=${crrTab}&page=${page}`, undefined, {
      shallow: true,
    })
  }

  const loadJoinedGroups = async () => {
    if (sessionUser?.profile) {
      const list = await loadGroups()
      return { list }
    }
    return { list: [] }
  }

  const { isFetching } = useQuery(
    ['groups', { page, crrTab }],
    () => !isCrrTabJoined && doLoadGroups({ type: crrTab, page }),
    {
      fetchPolicy: 'no-cache',
      onSuccess: state => {
        if (!isCrrTabJoined) {
          setListState(state)
        }
      },
    }
  )

  const { isFetching: groupsFetching } = useQuery(
    ['joined-groups', { page, crrTab, sessionUser }],
    () => isCrrTabJoined && loadJoinedGroups(),
    {
      fetchPolicy: 'no-cache',
      onSuccess: state => {
        if (isCrrTabJoined) {
          setListState(state)
        }
      },
    }
  )

  return (
    <S.Container>
      <S.Content>
        <S.TabsContainer>
          <Tabs.TabsHeader>
            <Tabs options={tabs} defaultValue={tab} onChange={changeTab} />
          </Tabs.TabsHeader>
          <S.TabsContent>
            {(!isCrrTabJoined && isFetching) ||
            (isCrrTabJoined && groupsFetching) ? (
              <Loading style={{ margin: '10px auto' }} />
            ) : !R.isEmpty(crrList) ? (
              <S.ListContainter>
                {crrList?.map((item, i) => {
                  const RenderItem = S.Group

                  return (
                    <RenderItem
                      {...item}
                      key={`group-${tab}-${i}`}
                      accessToken={accessToken}
                    />
                  )
                })}
                {total && (
                  <Pagination
                    style={{ marginTop: 32 }}
                    count={Math.ceil(total / 20)}
                    size={isMobile ? 'small' : 'medium'}
                    color="primary"
                    page={Number(page)}
                    onChange={(_, v) => {
                      changePage(v, tab)
                    }}
                  />
                )}
              </S.ListContainter>
            ) : (
              <S.EmptyContainer>
                {R.find(R.propEq(tab, 'value'), tabs)?.emptyMessage ||
                  'Nothing to see here'}
              </S.EmptyContainer>
            )}
          </S.TabsContent>
        </S.TabsContainer>
      </S.Content>
    </S.Container>
  )
}

List.defaultProps = defaultProps
List.propTypes = propTypes

export default withSizes(List)
